export const getInitials = (fullName = '') => {
  const nameList = fullName.split(' ');
  let initials = nameList[0].charAt(0);
  if (nameList.length > 1) {
    initials += nameList[nameList.length - 1].charAt(0);
  }
  return initials;
};
